import { authToken } from '@td/api';
import { useFetcher, useUpdater } from "@td/shared_utils";
import { useEffect, useState } from "react";

const payers = () => {
  const [payers, setPayers] = useState([]);
  const { data, loading, error } = useFetcher('/v4/payers');

  useEffect(() => {
    if (data) {
      setPayers(data.payers);
    }
  }, [loading]);

  return { payersLoading: loading, payersError: error, payers };
}

const skus = () => {
  const [skus, setSkus] = useState([]);
  const { data, loading, error } = useFetcher('/v4/sku_calculator/ref_skus');

  useEffect(() => {
    if (data) {
      setSkus(data.refSkus);
    }
  }, [loading]);

  return { skusLoading: loading, skusError: error, skus };
}

const cptCode = () => {
  const updater = useUpdater('get', {
    headers: { Authorization: `${authToken.get()}` }
  });

  const callApi = (formData) => {
    const baseUrl = '/v4/sku_calculator/cpt_code';
    const url = `${baseUrl}?${new URLSearchParams(formData).toString()}`;
    updater.callApi({}, url);
  };

  return { ...updater, callApi };
}

export { payers, skus, cptCode };
